import { render, staticRenderFns } from "./BuildingFormAdd.vue?vue&type=template&id=6735f7de&"
import script from "./BuildingFormAdd.vue?vue&type=script&lang=js&"
export * from "./BuildingFormAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports